module.exports = __webpack_public_path__ + "img/scan.52b72c42.png";